import { useState, useEffect, createElement } from "react";
import { toast } from "sonner";
import { upcomingHolidays } from "@/components/TimetableSection";
import { adminHeaders } from "@/components/admin/AdminLogin";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function buildOptions() {
  var els = [createElement("option", { key: "none", value: "" }, "Choose a holiday…")];
  for (var i = 0; i < upcomingHolidays.length; i++) {
    var name = upcomingHolidays[i].name;
    els.push(createElement("option", { key: name, value: name }, name));
  }
  return els;
}

export default function BookingBannerControl({ onUnauthorized }) {
  const [enabled, setEnabled] = useState(false);
  const [holiday, setHoliday] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(BACKEND_URL + "/api/booking-banner")
      .then((r) => r.json())
      .then((d) => { setEnabled(d.enabled); setHoliday(d.holiday || ""); })
      .catch(() => {});
  }, []);

  const save = async (nextEnabled) => {
    if (nextEnabled && !holiday) {
      toast.error("Please choose a holiday first.");
      return;
    }
    setSaving(true);
    try {
      const res = await fetch(BACKEND_URL + "/api/admin/booking-banner", {
        method: "PUT",
        headers: { "Content-Type": "application/json", ...adminHeaders() },
        body: JSON.stringify({ enabled: nextEnabled, holiday }),
      });
      if (res.status === 401) return onUnauthorized();
      if (!res.ok) throw new Error();
      setEnabled(nextEnabled);
      toast.success(nextEnabled ? "Banner is live: Booking now open for " + holiday : "Booking banner turned off");
    } catch {
      toast.error("Couldn't save. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm" data-testid="booking-banner-control">
      <div className="flex items-center justify-between gap-4 flex-wrap mb-4">
        <div>
          <h2 className="text-lg font-bold text-slate-900">"Booking Now Open" Banner</h2>
          <p className="text-sm text-gray-500">Replaces the countdown at the top of the site while it's on.</p>
        </div>
        <span
          className={"text-xs font-bold px-3 py-1 rounded-full " + (enabled ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500")}
          data-testid="booking-banner-status"
        >
          {enabled ? "LIVE" : "OFF"}
        </span>
      </div>
      <div className="flex gap-3 flex-wrap">
        <select
          value={holiday}
          onChange={(e) => setHoliday(e.target.value)}
          className="flex-1 min-w-[200px] border border-gray-200 rounded-lg px-3 py-2 text-sm"
          data-testid="booking-banner-holiday-select"
        >
          {buildOptions()}
        </select>
        <button
          onClick={() => save(true)}
          disabled={saving}
          className="bg-amber-500 hover:bg-amber-600 text-white text-sm font-bold px-4 py-2 rounded disabled:opacity-50"
          data-testid="booking-banner-turn-on"
        >
          {enabled ? "Update & keep on" : "Turn on"}
        </button>
        <button
          onClick={() => save(false)}
          disabled={saving || !enabled}
          className="bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-bold px-4 py-2 rounded disabled:opacity-50"
          data-testid="booking-banner-turn-off"
        >
          Turn off
        </button>
      </div>
    </div>
  );
}
